import VueRouter from 'vue-router';
// import components
import Resume from './pages/resume';
import Skills from './pages/skills';
import Services from './pages/services';
import Profile from './pages/profile';
import Pricing from './pages/pricing';
import Contact from './pages/contact';
import Unauthorized from './pages/unauthorized';
import Stat from './components/admin/stats';
import Crud from './pages/crud';
import Admin from './pages/admin';
import Quotations from './components/admin/quotations';
import Tasks from './components/admin/tasks';
import Users from './components/admin/users';
import QuotationGenerator from './pages/quotationGenerator';
import ConfidentialityRules from './pages/confidentialityRules';
import AppInfo from './pages/appInfo';
import Main from './pages/main';
import PermissionService from "./Services/permissionService";

const routes = [
  {
    path: '/resume',
    component: Resume
  },
  {
    path: '/skills',
    component: Skills
  },
  {
    path: '/services',
    component: Services
  },
  {
    path: '/profile',
    component: Profile
  },
  {
    path: '/unauthorized',
    component: Unauthorized
  },
  {
    path: '/pricing',
    component: Pricing
  },
  {
    path: '/contact',
    component: Contact
  },
  {
    path: '/manage',
    component: Admin,
    beforeEnter: PermissionService.hasPermission,
    children: [
      {
        path: '',
        component: Stat
      },
      {
        path: '/manage/quotations',
        component: Quotations
      },
      {
        path: '/manage/tasks',
        component: Tasks
      },
      {
        path: '/manage/users',
        component: Users
      }
    ]
  },
  {
    path: '/quotationGenerator',
    component: QuotationGenerator
  },
  {
    path: '/table',
    component: Crud
  },
  {
    path: '/ConfidentialityRules',
    component: ConfidentialityRules
  },
  {
    path: '/app/info',
    component: AppInfo
  },
  {
    path: '/',
    component: Main
  },
  {path: '*', redirect: '/'},
];

const router = new VueRouter({
  routes // short for `routes: routes`
});

export default router;
